"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSlidesLoopEnabled = void 0;
const DEFAULT_VALUE = true;
const isSlidesLoopEnabled = slider => {
  if (typeof slider?.loop === 'object') {
    return DEFAULT_VALUE;
  }
  return slider?.loop ?? DEFAULT_VALUE;
};
exports.isSlidesLoopEnabled = isSlidesLoopEnabled;
